export const ENVELOPE_SOURCE = "palazzo-vinci-widget" as const
export const ENVELOPE_VERSION = "v1" as const

export const WIDGET_READY_EVENT = "widget_ready" as const
export const PAGE_CONTEXT_ENABLED_EVENT = "page_context_enabled" as const

export const WIDGET_BASE_URL: string = process.env.WIDGET_BASE_URL ?? ""
